import React, { createContext, useContext, useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import styled from 'styled-components';

const SortableItemContext = createContext({
  attributes: {},
  listeners: undefined,
  ref() {}
});

export const SortableItem = ({ id, isLast, isFirst, children }) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({
      id: id
    });
  const context = useMemo(
    () => ({
      attributes,
      listeners,
      ref: setActivatorNodeRef
    }),
    [attributes, listeners, setActivatorNodeRef]
  );

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: 'relative'
  };

  return (
    <SortableItemContext.Provider value={context}>
      <div
        ref={setNodeRef}
        style={style}
        className={isLast ? 'last-collapse-item' : isFirst ? 'first-collapse-item' : ''}
      >
        {children}
        <DragHandle />
      </div>
    </SortableItemContext.Provider>
  );
};

function DragHandle() {
  const { attributes, listeners, ref } = useContext(SortableItemContext);

  return (
    <DragButton {...attributes} {...listeners} ref={ref}>
      <svg viewBox='0 0 20 20' width='12'>
        <path d='M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z'></path>
      </svg>
    </DragButton>
  );
}

const DragButton = styled.button`
  position: absolute;
  right: 16px;
  top: 8px;
  display: flex;
  width: 28px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background-color: transparent;
  border: none;
  cursor: grab;
  touch-action: none;
  border-radius: 5px;
  outline: none;
  appearance: none;
  z-index: 10;
  transition: 0.1s background-color ease-in;

  &:hover {
    background-color: rgba(140, 181, 234, 0.4);
  }

  svg {
    flex: 0 0 auto;
    margin: auto;
    height: 100%;
    overflow: visible;
    fill: #4c84c8;
  }
`;
